import React, { useEffect } from 'react';

function Contact() {
  // This effect will handle initialization of form validation and prevent constraint conflicts
  useEffect(() => {
    // If regula exists, override the PhoneNumber constraint to avoid duplicate registration
    if (window.regula && typeof window.regula.override === 'function') {
      try {
        window.regula.override({
          constraint: "PhoneNumber",
          // Basic configuration to prevent errors
          defaultMessage: "Invalid phone number format",
          validator: function() {
            return true;
          }
        });
      } catch (e) {
        console.log("Regula override failed, but it's okay:", e);
      }
    }
    
    // Initialize any form-related scripts after component mounts
    if (window.jQuery) {
      // Re-initialize any jQuery form plugins if needed
    }
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div>
      {/* Breadcrumbs */}
      <section className="breadcrumbs-custom-inset">
        <div className="breadcrumbs-custom context-dark bg-overlay-39">
          <div className="container">
            <h2 className="breadcrumbs-custom-title">Contact Us</h2>
            <ul className="breadcrumbs-custom-path">
              <li><a href="index.html">Home</a></li>
              <li className="active">Contact Us</li>
            </ul>
          </div>
          <div className="box-position" style={{backgroundImage:"url(assets/images/bg-breadcrumbs.jpg)"}}></div>
        </div>
      </section>
      
      {/* Contact information*/}
      <section className="section section-md section-first bg-default">
        <div className="container">
          <div className="row row-30 justify-content-center">
            <div className="col-sm-8 col-md-6 col-lg-4">
              <article className="box-contacts">
                <div className="box-contacts-body">
                  <div className="box-contacts-icon fl-bigmug-line-cellphone55"></div>
                  <div className="box-contacts-decor"></div>
                  <p className="box-contacts-link"><a href="tel:#">+973 3365778</a></p>
                  <p className="box-contacts-link"><a href="tel:#">+1 323-888-4554</a></p>
                </div>
              </article>
            </div>
            <div className="col-sm-8 col-md-6 col-lg-4">
              <article className="box-contacts">
                <div className="box-contacts-body">
                  <div className="box-contacts-icon fl-bigmug-line-up104"></div>
                  <div className="box-contacts-decor"></div>
                  <p className="box-contacts-link"><a href="#">4730 Crystal Springs, Salmabad, Bahrain</a></p>
                </div>
              </article>
            </div>
            <div className="col-sm-8 col-md-6 col-lg-4">
              <article className="box-contacts">
                <div className="box-contacts-body">
                  <div className="box-contacts-icon fl-bigmug-line-chat55"></div>
                  <div className="box-contacts-decor"></div>
                  <p className="box-contacts-link"><a href="mailto:#">sales@zartecsolutions.com</a></p>
                  <p className="box-contacts-link"><a href="mailto:#">marketing@zartecsolutions.com</a></p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form and Google Map */}
      <section className="section section-md section-last bg-default text-md-left">
        <div className="container">
          <div className="row row-50">
            <div className="col-lg-6 section-map-small">
              <div className="map-contact pt-5">
                <iframe 
                  className="map-w3layouts" 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.6314045205954!2d50.521010974396724!3d26.17613119135835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49aff270b9818b%3A0x3cfb8a4983741548!2sZartec%20Solutions!5e0!3m2!1sen!2sbh!4v1740993207912!5m2!1sen!2sbh" 
                  width="100%" 
                  height="450" 
                  style={{border:"0"}} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps Location">
                </iframe>
              </div>
            </div>
            <div className="col-lg-6">
              <h4 className="text-spacing-50">Contact Form</h4>
              <form className="rd-form rd-mailform" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">
                <div className="row row-14 gutters-14">
                  <div className="col-sm-6">
                    <div className="form-wrap">
                      <input className="form-input" id="contact-first-name" type="text" name="name" data-constraints="@Required"/>
                      <label className="form-label" htmlFor="contact-first-name">First Name</label>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-wrap">
                      <input className="form-input" id="contact-last-name" type="text" name="name" data-constraints="@Required"/>
                      <label className="form-label" htmlFor="contact-last-name">Last Name</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-wrap">
                      <input className="form-input" id="contact-email" type="email" name="email" data-constraints="@Email @Required"/>
                      <label className="form-label" htmlFor="contact-email">E-mail</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-wrap">
                      <label className="form-label" htmlFor="contact-message">Message</label>
                      <textarea className="form-input" id="contact-message" name="message" data-constraints="@Required"></textarea>
                    </div>
                  </div>
                </div>
                <button className="button button-primary button-pipaluk" type="submit">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;